import { FC, useEffect } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import TextField from "../../shared/base-components/TextField";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";
import { BUY_SELL_TYPES, RESPONSE_CODE } from "../../shared/models/Types";
import { successNotify } from "../../shared/utils/notifications";
import { StaffAddRequest } from "../Staff/Staff.constants";
import {
  DevicePartBuySellModalProps,
  payOptions,
  DevicePartBuySellRequest,
  deviceBuySellSchema,
} from "./Stock.constants";
import { useDevicePartBuySellMutation } from "./Stock.actions";
import SelectBox from "../../shared/base-components/SelectBox";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSupplierListMutation } from "../Supplier/Supplier.actions";

const DevicePartBuySellModal: FC<DevicePartBuySellModalProps> = ({
  modalData,
  isModalOpen,
  toggle,
  devicePartListMutation,
}) => {
  const isBuy = modalData?.modalType === BUY_SELL_TYPES.BUY;

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({ resolver: yupResolver(deviceBuySellSchema) });

  const { data, mutate, isLoading } = useDevicePartBuySellMutation();
  const {
    data: supplierList,
    mutate: supplierMutate,
    isLoading: supplierLoading,
  } = useSupplierListMutation();

  const onSubmit: SubmitHandler<any> = (requestValues) => {
    if (modalData?.id) {
      const requestForm: DevicePartBuySellRequest = {
        device_part: modalData?.id,
        amount: requestValues.amount,
        total_price: 0,
        // total_price: requestValues.total_price,
        content_type: isBuy ? 1 : 2,
        payment_type: requestValues.payment_type,
        note: requestValues.note,
        date: new Date(),
        supplier: requestValues.supplier,
      };

      mutate(requestForm);
    }
  };

  useEffect(() => {
    if (data?.status === RESPONSE_CODE.CREATED) {
      successNotify(
        isBuy
          ? "Alış başarılı bir şekilde oluşturuldu"
          : "Satış başarılı bir şekilde oluşturuldu"
      );
      toggle();
      devicePartListMutation({});
    }

    supplierList === undefined && supplierMutate({});
  }, [data]);

  const supplierValues = supplierList?.map((supplier) => ({
    key: supplier?.name,
    value: supplier?.id,
  }));

  return (
    <ModalComponent
      header={isBuy ? "Alış Ekle" : "Satış Ekle"}
      description={
        isBuy
          ? "Alış eklemek için gerekli alanları doldurunuz."
          : "Satış eklemek için gerekli alanları doldurunuz."
      }
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Miktar</Label>
              <TextField
                control={control}
                name="amount"
                type="number"
                className="form-control"
                placeholder="Miktar"
                error={errors.amount?.message}
              />
            </FormGroup>
          </Col>

          {/* <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Toplam Fiyat</Label>
              <TextField
                control={control}
                name="total_price"
                className="form-control"
                type="number"
                placeholder="Toplam Fiyat"
                error={errors.total_price?.message}
              />
            </FormGroup>
          </Col> */}

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Not</Label>
              <TextField
                control={control}
                name="note"
                type="text"
                className="form-control"
                placeholder="Not"
                error={errors.note?.message}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom02">Ödeme Tipi</Label>
              <SelectBox
                control={control}
                defaultValue={1}
                name="payment_type"
                className="form-control"
                options={payOptions}
              />
            </FormGroup>
          </Col>

          <Col sm="12" md="6" lg="6">
            <FormGroup className="mb-3">
              <Label className="form-label">Tedarikçi</Label>
              <SelectBox
                control={control}
                name="supplier"
                className="form-control"
                options={[
                  {
                    key: "Lütfen tedarikçi seçin",
                    value: -1,
                  },
                  ...(supplierValues || []),
                ]}
              />
            </FormGroup>
          </Col>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={isLoading}
                text={isBuy ? "Alış Ekle" : "Satış Ekle"}
                variant="primary"
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default DevicePartBuySellModal;
